/* eslint-disable */
//The linter does not like prop spreading, but dropzone requires it
import React, { memo } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import classes from './atmosphericLogDropzone.module.css';
import { Icon } from 'Components/Icons';

interface Props {
  getRootProps: any;
  getInputProps: any;
}

const AtmosphericLogDropzone = ({ getRootProps, getInputProps }: Props) => (
  <>
    <div className={`${classes.dropZoneWrapper}`} {...getRootProps()}>
      <input {...getInputProps()} />
      <div className={classes.container}>
        <div className={`d-flex justify-content-center ${classes.uploadIconContainer}`}>
          <div className={classes.uploadIcon}>
            <Icon type="dropzoneBackground" />
          </div>
        </div>
        <p className={classes.messageContainer}>Click or drop to upload</p>
      </div>
    </div>
  </>
);

const AtmosphericLogDropzoneMemo = memo(AtmosphericLogDropzone, areEqual);
export { AtmosphericLogDropzoneMemo as AtmosphericLogDropzone };
